import { createClient } from '@supabase/supabase-js';

// API Configuration
const API_URL = (() => {
  const envUrl = process.env.REACT_APP_API_URL;
  
  if (envUrl && envUrl.trim()) {
    return envUrl.trim();
  }
  
  // Fallback par défaut
  return "http://127.0.0.1:8000";
})();

console.log("API_URL configured as:", API_URL);

// Supabase Configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables not configured');
}

const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

export { API_URL, supabase };
